import Axios from './axios_wrapper'

export function getHospitals(page) {
  return Axios({
    url: `/hospitals`,
    method: 'GET',
    page
  })
}

export function getHospitalsWithoutPagination() {
  return Axios({
    url: `/hospitals?no_pagination=true`,
    method: 'GET'
  })
}

export function createHospital(data) {
  return Axios({
    url: `/hospitals`,
    method: 'POST',
    data
  })
}

export function getHospital(id, noPagination) {
  const url = noPagination ? `/hospitals/${id}&no_pagination=true` : `/hospitals/${id}` 

  return Axios({
    url: url,
    method: 'GET'
  })
}

export function getHospitalAdmin(id) {
  return Axios({
    url: `/admin/hospitals/${id}`,
    method: 'GET'
  })
}

export function deleteHospital({ id }) {
  return Axios({
    url: `/hospitals/${id}`,
    method: 'DELETE'
  })
}

export function updateHospital(id, data) {
  return Axios({
    url: `/hospitals/${id}`,
    method: 'PATCH',
    data
  })
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/hospitals.js
// module id = null
// module chunks = 